import React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

export const SvgComponent = props => (
    <Svg width={126} height={24} viewBox="0 0 126 24" fill="none" {...props}>
        <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.00475793 15.9372L1.8453 3.52103C1.91557 3.04536 2.28314 2.66833 2.75611 2.58455L17.3656 0.00887184C17.8196 -0.0708579 18.1696 0.402115 17.9602 0.812926L13.8156 8.94401C13.6061 9.35482 13.9561 9.82779 14.4102 9.74806L18.2237 9.07509C18.7683 8.97914 19.1061 9.64806 18.7061 10.0305L4.2007 23.8427C3.78584 24.2372 3.11692 23.8278 3.28043 23.2791L5.27368 16.5764C5.39259 16.1778 5.0507 15.7954 4.64124 15.867L0.65611 16.5697C0.280435 16.6359 -0.0492948 16.3143 0.0061106 15.9372H0.00475793ZM9.02368 10.3305C9.73719 10.6102 10.1926 10.7886 10.0304 9.87103C9.74395 8.24266 8.21827 7.15076 6.62233 7.4332C5.02773 7.71428 3.96692 9.26157 4.25341 10.89C4.41557 11.8075 4.78179 11.4845 5.35746 10.9764C5.80206 10.5845 6.37232 10.0818 7.06827 9.95887C7.76422 9.8359 8.47097 10.1129 9.02368 10.3305Z"
            fill={ds.colorValue.icon.primary}
        />
        <Path
            d="M116.429 19.2598V8.8198H111.749V4.7398H125.969V8.8198H121.309V19.2598H116.429Z"
            fill={ds.colorValue.icon.primary}
        />
        <Path
            d="M105.187 19.5398C100.107 19.5398 96.0274 16.5198 96.0274 12.0598C96.0274 7.87981 99.6474 4.45981 105.267 4.45981C106.967 4.45981 108.967 4.79981 110.487 5.71981L110.627 10.6198C109.147 9.23981 107.427 8.55981 105.647 8.55981C103.407 8.55981 101.267 9.81981 101.267 11.9998C101.267 14.1598 103.347 15.4398 105.707 15.4398C107.367 15.4398 109.267 14.8398 110.907 13.3798L110.307 18.1998C109.107 19.0398 107.327 19.5398 105.187 19.5398Z"
            fill={ds.colorValue.icon.primary}
        />
        <Path d="M89.5589 19.2598V4.7398H94.4989V19.2598H89.5589Z" fill={ds.colorValue.icon.primary} />
        <Path
            d="M72.311 19.2598V4.7398H79.331C84.391 4.7398 88.031 7.5398 88.031 11.9598C88.031 16.4598 84.331 19.2598 79.371 19.2598H72.311ZM78.711 15.2798C80.951 15.2798 82.791 14.4798 82.791 12.0198C82.791 9.5998 81.131 8.71981 78.671 8.71981H77.171V15.2798H78.711Z"
            fill={ds.colorValue.icon.primary}
        />
        <Path
            d="M58.5414 19.2598V4.7398H70.7814V8.6598H63.2214V10.3798H68.7214V13.5198H63.2214V15.3198H70.7614L70.7814 19.2598H58.5414Z"
            fill={ds.colorValue.icon.primary}
        />
        <Path
            d="M42.5453 19.2598V4.7398H50.0653C55.0853 4.7398 56.7053 7.2798 56.7053 9.4398C56.7053 11.4398 55.1853 13.2598 52.7053 13.9998L57.4453 19.2598H51.6053L47.5853 14.3598H47.3653V19.2598H42.5453ZM49.7253 11.0798C50.8053 11.0798 51.6853 10.5598 51.6853 9.7198C51.6853 8.8398 50.8253 8.3998 49.7453 8.3998H47.3653V11.0798H49.7253Z"
            fill={ds.colorValue.icon.primary}
        />
        <Path
            d="M26.8813 19.2598V4.7398H34.1013C39.5213 4.7398 41.3013 7.35981 41.3013 10.0198C41.3013 12.7998 39.1813 15.3598 34.2213 15.3598H31.7413V19.2598H26.8813ZM33.7013 11.6198C35.1013 11.6198 36.1613 11.0998 36.1613 10.0198C36.1613 8.93981 35.1613 8.4798 33.7013 8.4798H31.7413V11.6198H33.7013Z"
            fill={ds.colorValue.icon.primary}
        />
    </Svg>
);

export default SvgComponent;
